import { dateToHoneycombInput } from '../datetime';

export const constructEditDriverData = (data) => {
	const { phone, startTime, medicalCheckExpiresAt, driverLicenseExpiresAt } = data;

	const editData = {
		phone,
		startTime: dateToHoneycombInput(startTime),
		medicalCheckExpiresAt: dateToHoneycombInput(medicalCheckExpiresAt),
		driverLicenseExpiresAt: dateToHoneycombInput(driverLicenseExpiresAt),
	};

	Object.keys(editData).forEach((key) => {
		if (editData[key] === null) editData[key] = '';
	});
	Object.keys(editData).forEach((key) => {
		if (editData[key] === null) editData[key] = '';
	});
	return editData;
};

export const buildUncontrolledDataForMutation = (data) => {
	const { email, endTime, drugTestExpiresAt, isActive } = data;
	return {
		email,
		endTime,
		drugTestExpiresAt,
		isActive,
	};
};
